/**
 * Shared predicate for detecting stale dynamic-import / chunk-load failures
 * that happen after a deploy. Used by both the global error handler (to
 * trigger an auto-reload) and by route-level lazy factories (to retry).
 */
export function isStaleChunkError(input: unknown): boolean {
  const err = input instanceof Error ? input : new Error(String(input ?? ""));
  const msg = err.message || "";
  const name = err.name || "";
  return (
    /Failed to fetch dynamically imported module/i.test(msg) ||
    /Importing a module script failed/i.test(msg) ||
    /error loading dynamically imported module/i.test(msg) ||
    /ChunkLoadError/i.test(name) ||
    /Loading chunk \d+ failed/i.test(msg) ||
    /Loading CSS chunk/i.test(msg)
  );
}
